import InfoBoard from './InfoBoard';

export default InfoBoard;
